import {DowntimePageReferer} from '../../shared/consts'
import {
  MAJOR_OUTAGE_LEAD_DOWNTIME,
  MAJOR_OUTAGE_LEAD_DOWNTIME_STOPPAGES,
  MAJOR_OUTAGE_LEAD_DOWNTIME_STOPPAGES_DETAILS,
  MAJOR_OUTAGE_LEAD_DOWNTIME_STOPPAGES_DETAILS_FOR_CODE,
  PLANT_DOWNTIME_STOPPAGES,
  PLANT_DOWNTIME_STOPPAGES_DETAILS,
  PLANT_DOWNTIME_STOPPAGES_DETAILS_FOR_CODE,
  PLANT_MAJOR_OUTAGE_LEAD_DASHBOARD
} from '../../shared/routes'
import {PLANT_DOWNTIME, PLANT_DOWNTIME_STATS} from '../routing'

export const DowntimePathMap: Record<DowntimePageReferer, string> = {
  [DowntimePageReferer.DOWNTIME]: PLANT_DOWNTIME,
  [DowntimePageReferer.MAJOR_OUTAGE_LEAD_DASHBOARD]: MAJOR_OUTAGE_LEAD_DOWNTIME
}

export const DowntimeStoppagesPathMap: Record<DowntimePageReferer, string> = {
  [DowntimePageReferer.DOWNTIME]: PLANT_DOWNTIME_STOPPAGES,
  [DowntimePageReferer.MAJOR_OUTAGE_LEAD_DASHBOARD]: MAJOR_OUTAGE_LEAD_DOWNTIME_STOPPAGES
}

export const DowntimeStoppageDetailsPathMap: Record<DowntimePageReferer, string> = {
  [DowntimePageReferer.DOWNTIME]: PLANT_DOWNTIME_STOPPAGES_DETAILS,
  [DowntimePageReferer.MAJOR_OUTAGE_LEAD_DASHBOARD]: MAJOR_OUTAGE_LEAD_DOWNTIME_STOPPAGES_DETAILS
}

export const DowntimeStoppageDetailsForCodePathMap: Record<DowntimePageReferer, string> = {
  [DowntimePageReferer.DOWNTIME]: PLANT_DOWNTIME_STOPPAGES_DETAILS_FOR_CODE,
  [DowntimePageReferer.MAJOR_OUTAGE_LEAD_DASHBOARD]:
    MAJOR_OUTAGE_LEAD_DOWNTIME_STOPPAGES_DETAILS_FOR_CODE
}

export const DowntimeKilnStatsPagePathMap: Record<DowntimePageReferer, string> = {
  [DowntimePageReferer.DOWNTIME]: PLANT_DOWNTIME_STATS,
  [DowntimePageReferer.MAJOR_OUTAGE_LEAD_DASHBOARD]: PLANT_MAJOR_OUTAGE_LEAD_DASHBOARD
}

// #region mtmYtmStats section start
export const DowntimeStatisticsViewToggleOptions = {
  YTM_VIEW: 'yearToMonthKpis',
  MTM_VIEW: 'monthToMonthKpis'
} as const

export type DowntimeStatisticsViewToggleOption =
  (typeof DowntimeStatisticsViewToggleOptions)[keyof typeof DowntimeStatisticsViewToggleOptions]

export const DOWNTIME_STATISTICS_TOGGLE_VIEWS = Object.values(
  DowntimeStatisticsViewToggleOptions
) as DowntimeStatisticsViewToggleOption[]
// #endregion mtmYtmStats section start
